export default __webpack_public_path__ + "static/media/DarkLocation.7a41a375.svg";